export type CurrencyCode = "EUR" | "GBP" | "CHF" | "ARS"

export const DEFAULT_CURRENCY_CODE: CurrencyCode = "EUR"

export const normalizeCurrencyCode = (currencyCode?: string): CurrencyCode => {
    if (!currencyCode) return DEFAULT_CURRENCY_CODE
    const normalized = currencyCode.toUpperCase()
    if (normalized === "GBP") return "GBP"
    if (normalized === "CHF") return "CHF"
    if (normalized === "ARS") return "ARS"
    return "EUR"
}

export const getCurrencySymbol = (currencyCode?: string): string => {
    const normalized = normalizeCurrencyCode(currencyCode)
    if (normalized === "GBP") return "£"
    if (normalized === "CHF") return "CHF"
    if (normalized === "ARS") return "$"
    return "€"
}

export const getCurrencySymbolFromEntity = (entity?: {
    settings?: { currency?: string }
}): string => {
    return getCurrencySymbol(entity?.settings?.currency)
}
